<script setup lang="ts">
import { ComboboxOption } from '@headlessui/vue'

interface Props {
  as?: 'button' | 'ComboboxOption'
  selected?: boolean
}

const { as = 'ComboboxOption' } = defineProps<Props>()
</script>

<template>
  <Component
    :is="as === 'button' ? 'button' : ComboboxOption"
    :class="{
      '!bg-primary text-white': selected,
    }"
    class="relative flex cursor-pointer items-center justify-center gap-2 rounded border-2 border-[#537390] bg-white px-4 py-1.5 text-center capitalize shadow-md transition md:min-w-[calc(12.5%-7px)] hover:scale-105 focus:outline-none"
  >
    <slot />
  </Component>
</template>
